import React, { useEffect, useRef, useState } from "react";
import "../styles/AssessmentQuestionPageStyle.css";
import "../../codehub/styles/CodeHubStyles.css";
import ReviewFlag from "../../../assets/images/assessment/review_flag.png";
import "react-horizontal-scrolling-menu/dist/styles.css";
import ForwardImg from "../../../assets/images/assessment/forward_img.png";
import BackwardImg from "../../../assets/images/assessment/backward_img.png";
import BackwardImgDisabled from "../../../assets/images/assessment/backwardEnabled.svg";
import ForwardImgDisabled from "../../../assets/images/assessment/forwardEnabled.svg";
import Loader, { LocalStorage } from "../../../utils/Utils";
import JozunaLogo from "../../sidebar/assets/sidebarIcons/jozunaExpandedLogo.svg";
import Logout from "../../../assets/images/assessment/logoutIcon.svg";
import { Col, Row } from "reactstrap";
import AssessmentTimer from "../../../components/AssessmentTimer";
import AssessmentQuestionModuleApiService from "../data/api_services/QuestionModuleApi";
import strings from "../../../utils/Strings";
import { useAlert } from "../../../components/AlertContextComponent";
import {
  OptionModel,
  QuestionListModel,
  UserInput,
} from "../data/response/QuestionListModel";
import { Item } from "../data/response/ResumeResponse";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../store/store";
import { AssessmentAnswerRequest } from "../data/request/AssessmentAnswerRequest";
import CommonUtils from "../../../utils/Common_Utils";
import HeartBeatTimer from "../components/HeartBeatTimer";
import { useApi } from "../../../service/ApiContext";
import AssessmentQuestionModuleClient from "../data/client/AssessmentQuestionModuleClient";
import Logger from "../../../utils/Logger";
import { clearAssessment } from "../../assessment/data/redux/AssessmentSlice";
import { useNavigate } from "react-router-dom";
import ErrorAlertPopup from "../../../components/AlertErrorPopupComponent";
import { Heartbeat } from "../data/response/heartBeatReponse";
import ZoomableImage from "../components/ImageZoomable_Component";
import hamburgerMenu from "../../assessment/assets/allAssessment/hamburgermen.svg";
import { time } from "console";
import {
  OverlayErrorPoppup,
  OverlaySingleErrorPoppup,
} from "../../../components/OverlayErrorPopup";
import {
  logActionEvent,
  logPageView,
} from "../../../analytics/analytics_utils";
import analytics_strings from "../../../analytics/analytics_strings";
import SuccessSnackPopUp from "../../../components/SuccessSnackPopup";
// New imports for code editor enhancements
import CodeMirror from "@uiw/react-codemirror";
import { python } from "@codemirror/lang-python";
import { javascript } from "@codemirror/lang-javascript";
import { java } from "@codemirror/lang-java";
import { oneDark } from "@codemirror/theme-one-dark";
import { indentWithTab } from "@codemirror/commands";
import { keymap } from "@codemirror/view";
import { EditorView } from "@codemirror/view";
import { autocompletion } from "@codemirror/autocomplete";
import { LogOutResponse } from "../data/response/AnswerResponse";
import AudioPlayer from "../../AudioPlayer/components/AudioPlayer";
import AssessmentBubbleSelector from "../components/QuestionCountStepper_Component";
import cancelIcon from "../../assessment/assets/allAssessment/menuCancelIcon.svg";
import infoIcon from "../../assessment/assets/allAssessment/assessmentInfo.svg";
import instructionIcon from "../../assessment/assets/allAssessment/instructionIcon.svg";
import themeIcon from "../../assessment/assets/allAssessment/themeIcon.png";
import darkmenu from "../../assessment/assets/allAssessment/darkthemeHamburger.svg";
import darkCancel from "../../assessment/assets/allAssessment/darkthemeCancel.svg";
import darkthemeIcon from "../../assessment/assets/allAssessment/switch-on 1.svg";
import { instructionList } from "../interface/AssessmentInstConst";
import CardBottomOverlay from "../../dashboard/components/CardBottomOverlay";
import CameraPopup from "../../assessment_activeproctoring/component/AssessmentCamPopup";
import { useProctoring } from "../../assessment_activeproctoring/hooks/ActiveProctoringContext";
import Loading from "../../../components/LoaderComponent";

// Add validation utilities
interface ValidationResult {
  isValid: boolean;
  errors: string[];
  warnings: string[];
}

const validatePythonCode = (code: string): ValidationResult => {
  const errors: string[] = [];
  const warnings: string[] = [];

  // Check for common Python syntax errors
  const lines = code.split("\n");

  // Check indentation consistency
  const indentStack: number[] = [];
  let hasInconsistentIndent = false;

  lines.forEach((line, index) => {
    const trimmedLine = line.trim();
    if (trimmedLine === "" || trimmedLine.startsWith("#")) return;

    const indent = line.search(/\S/);

    if (trimmedLine.endsWith(":")) {
      indentStack.push(indent);
    } else if (
      trimmedLine.startsWith("return") ||
      trimmedLine.startsWith("break") ||
      trimmedLine.startsWith("continue") ||
      trimmedLine.startsWith("pass")
    ) {
      // These statements should be at the same indentation as their block
      if (
        indentStack.length > 0 &&
        indent !== indentStack[indentStack.length - 1] + 4
      ) {
        if (indent !== indentStack[indentStack.length - 1]) {
          warnings.push(
            `Line ${index + 1}: ${trimmedLine} statement should be indented ${indentStack[indentStack.length - 1] + 4} spaces`,
          );
        }
      }
    } else if (trimmedLine === "" || trimmedLine.startsWith("#")) {
      // Skip empty lines and comments
    } else {
      // Check if this line should be dedented
      if (
        indentStack.length > 0 &&
        indent < indentStack[indentStack.length - 1]
      ) {
        while (
          indentStack.length > 0 &&
          indent <= indentStack[indentStack.length - 1]
        ) {
          indentStack.pop();
        }
      }

      // Check indentation consistency
      if (
        indentStack.length > 0 &&
        indent > indentStack[indentStack.length - 1]
      ) {
        if (indent !== indentStack[indentStack.length - 1] + 4) {
          hasInconsistentIndent = true;
          warnings.push(
            `Line ${index + 1}: Inconsistent indentation (${indent} spaces, expected ${indentStack[indentStack.length - 1] + 4} spaces)`,
          );
        }
      }
    }
  });

  // Check for unbalanced parentheses/brackets/braces
  const stack: string[] = [];
  const pairs: { [key: string]: string } = { "(": ")", "[": "]", "{": "}" };

  for (let i = 0; i < code.length; i++) {
    const char = code[i];
    if (char === "(" || char === "[" || char === "{") {
      stack.push(char);
    } else if (char === ")" || char === "]" || char === "}") {
      const last = stack.pop();
      if (last && pairs[last] !== char) {
        errors.push(
          `Mismatched closing bracket at position ${i}: expected ${pairs[last]}, found ${char}`,
        );
      }
    }
  }

  if (stack.length > 0) {
    errors.push(`Unclosed ${stack.join(", ")}`);
  }

  return { isValid: errors.length === 0, errors, warnings };
};

const validateJavaScriptCode = (code: string): ValidationResult => {
  const errors: string[] = [];
  const warnings: string[] = [];

  // Check for common JavaScript syntax errors
  const lines = code.split("\n");

  // Check for missing semicolons
  lines.forEach((line, index) => {
    const trimmedLine = line.trim();
    if (
      trimmedLine &&
      !trimmedLine.endsWith(";") &&
      !trimmedLine.endsWith("{") &&
      !trimmedLine.endsWith("}") &&
      !trimmedLine.startsWith("//") &&
      !trimmedLine.startsWith("/*") &&
      !trimmedLine.startsWith("*") &&
      !trimmedLine.startsWith("function") &&
      !trimmedLine.startsWith("if") &&
      !trimmedLine.startsWith("for") &&
      !trimmedLine.startsWith("while") &&
      !trimmedLine.startsWith("switch") &&
      !trimmedLine.startsWith("try") &&
      !trimmedLine.startsWith("catch") &&
      !trimmedLine.startsWith("class") &&
      !trimmedLine.startsWith("import") &&
      !trimmedLine.startsWith("export") &&
      !trimmedLine.startsWith("return")
    ) {
      warnings.push(`Line ${index + 1}: Consider adding semicolon at the end`);
    }
  });

  // Check for balanced parentheses/brackets/braces
  const stack: string[] = [];
  const pairs: { [key: string]: string } = { "(": ")", "[": "]", "{": "}" };

  for (let i = 0; i < code.length; i++) {
    const char = code[i];
    if (char === "(" || char === "[" || char === "{") {
      stack.push(char);
    } else if (char === ")" || char === "]" || char === "}") {
      const last = stack.pop();
      if (last && pairs[last] !== char) {
        errors.push(
          `Mismatched closing bracket at position ${i}: expected ${pairs[last]}, found ${char}`,
        );
      }
    }
  }

  if (stack.length > 0) {
    errors.push(`Unclosed ${stack.join(", ")}`);
  }

  // Check for variable declarations
  if (code.includes("var ")) {
    warnings.push("Consider using let or const instead of var");
  }

  return { isValid: errors.length === 0, errors, warnings };
};

const validateJavaCode = (code: string): ValidationResult => {
  const errors: string[] = [];
  const warnings: string[] = [];

  // Check for class declaration
  if (!code.includes("class ")) {
    warnings.push("No class declaration found");
  }

  // Check for main method in class
  if (code.includes("class ") && !code.includes("public static void main")) {
    warnings.push("No main method found");
  }

  // Check for balanced braces
  const openBraces = (code.match(/{/g) || []).length;
  const closeBraces = (code.match(/}/g) || []).length;

  if (openBraces !== closeBraces) {
    errors.push(
      `Unbalanced braces: ${openBraces} opening, ${closeBraces} closing`,
    );
  }

  // Check for semicolons
  const lines = code.split("\n");
  lines.forEach((line, index) => {
    const trimmedLine = line.trim();
    if (
      trimmedLine &&
      !trimmedLine.endsWith(";") &&
      !trimmedLine.endsWith("{") &&
      !trimmedLine.endsWith("}") &&
      !trimmedLine.startsWith("//") &&
      !trimmedLine.startsWith("/*") &&
      !trimmedLine.startsWith("*") &&
      !trimmedLine.startsWith("import") &&
      !trimmedLine.startsWith("package") &&
      !trimmedLine.startsWith("@")
    ) {
      warnings.push(`Line ${index + 1}: Missing semicolon`);
    }
  });

  return { isValid: errors.length === 0, errors, warnings };
};

// Language-specific extensions for CodeMirror
const getLanguageExtension = (language: string) => {
  switch (language.toLowerCase()) {
    case "python":
      return python();
    case "javascript":
    case "js":
      return javascript({ jsx: false, typescript: false });
    case "java":
      return java();
    default:
      return python();
  }
};

interface AssessmentbubbleComponentProps {
  setIsFeedbackFormVisible: React.Dispatch<React.SetStateAction<boolean>>;
  isFeedbackVisible: boolean;
  isChildWindowOpen: boolean;
  setIsChildWindowOpen: React.Dispatch<React.SetStateAction<boolean>>;
  selectedAssessment: any;
}

const AssessmentQuestionPage: React.FC<AssessmentbubbleComponentProps> = ({
  setIsFeedbackFormVisible,
  isFeedbackVisible,
  isChildWindowOpen,
  setIsChildWindowOpen,
  selectedAssessment,
}) => {
  // HeartBeat Declartions start
  const [heartBeatApiResponse, setHeartBeatApiResponse] = useState<
    string | null
  >(null);
  const [isHeartBeartRunning, setHeartBeartRunning] = useState<boolean>(false);
  //Ref for the HeartBeatTimer Instance
  const heartBeatTimerRef = useRef<HeartBeatTimer | null>(null);
  let timeSpended = useSelector(
    (state: RootState) => state.assessment.timeReduxSpend,
  );
  const [isDarkTheme, setIsDarkTheme] = useState(false);
  const [showSubjectPopup, setShowSubjectPopup] = useState(false);

  let [timeChange, setTimeChange] = useState(10);
  useEffect(() => {
    setTimeChange(timeSpended);
    LocalStorage.setLocalData("elapsedTime", timeSpended.toString());
  }, [timeSpended]);

  //------Common Declarations
  const questionModuleApiService = AssessmentQuestionModuleApiService(); //API Service Class for question module
  const { showAlert } = useAlert();

  //------Variable Declarations
  const totalDuration = useSelector(
    (state: RootState) => state.assessment.duration,
  );
  const api = useApi();
  const navigate = useNavigate();
  const [isPopup, setIsPopup] = useState<boolean>(false);
  const assessmentId = useSelector(
    (state: RootState) => state.assessment.assessmentId,
  );
  const duration = useSelector((state: RootState) => state.assessment.duration);
  // Select the data from the Redux store
  const userData = useSelector((state: RootState) => state.profile.profileKeys);
  const dispatch = useDispatch();
  const timerRef = useRef<any>(null); // Reference to the AssessmentTimer
  const [currentIndex, setCurrentIndex] = useState<number>(0); //Current Selected Question Index
  const totalQuestions = parseInt(
    LocalStorage.getLocalData(
      strings.localStorage_keys.assessment_details.total_question,
    ) || "0",
  ); //total Question count from local storage
  const [showNotification, setShowNotification] = useState<string | null>(null); //LogOut Notifications
  const questionContainerRef = useRef<HTMLDivElement>(null);
  const optionRefs = useRef<HTMLDivElement[]>([]); //option height variables
  const [questionHeight, setQuestionHeight] = useState<number>(0);
  //------Question Related Variable Declarations
  const [startTimePerQuestions, setStartTimePerQuestions] =
    useState<Date | null>(null); //to store per question taken time
  const [selectedAnswerId, setSelectedAnswerId] = useState<string | null>(null); // To store selected AnswerId
  const [questionModelList, setQuestionModelList] = useState<
    QuestionListModel[]
  >([]); // To store all the received questions from backend
  const { setupStep, cameraStream } = useProctoring();

  const isCameraRequired = (() => {
    const propVal = selectedAssessment?.is_camera_required;
    if (typeof propVal === "boolean") return propVal;
    if (typeof propVal === "string")
      return propVal.toLowerCase() === "true" || propVal === "1";
    if (typeof propVal === "number") return propVal === 1;

    const localVal = LocalStorage.getLocalData(
      strings.localStorage_keys.assessment_details.is_camera_required,
    );
    if (localVal !== null && localVal !== undefined && localVal !== "") {
      return (
        localVal.toString().toLowerCase() === "true" ||
        localVal.toString() === "1"
      );
    }
    return true; // Default fallback
  })();

  // Refs to track current state for heartbeat callback (avoid closure issues)
  const questionModelListRef = useRef<QuestionListModel[]>([]);
  const currentIndexRef = useRef<number>(0);

  const [descriptiveText, setDescriptiveText] = useState<string | null>(null); //to store current descriptive textfield
  const [isLoading, setIsLoading] = useState<boolean>(false); //while fetching & saving for disable save next button
  const [isReviewErrorPopup, setIsReviewErrorPopup] = useState<boolean>(false);
  const [isSetErrorMsg, setIsErrorMsgPopup] = useState<string | null>(null); //show error popups
  const [isTimeUp, setIsTimeUp] = useState(false); ///TimeUp on Timer Handle the Submit api call
  const [openMenu, setOpenMenu] = useState(false);

  const menuItems = [
    { label: "Assessment Details", icon: infoIcon },
    { label: "Instructions", icon: instructionIcon },
    // { label: "Switch Theme", icon: isDarkTheme ? darkthemeIcon : themeIcon },
  ];

  const [showInstructionsPopup, setShowInstructionsPopup] = useState(false);
  // Programming IDE states
  const [codeContent, setCodeContent] = useState<string>("");
  const [selectedProgrammingLanguage, setSelectedProgrammingLanguage] =
    useState<string>("Python");
  const [runOutput, setRunOutput] = useState<any>(null);
  const [isRunningCode, setIsRunningCode] = useState<boolean>(false);
  // New state for code validation
  const [validationResult, setValidationResult] =
    useState<ValidationResult | null>(null);
  const [showValidation, setShowValidation] = useState<boolean>(false);
  const [editorView, setEditorView] = useState<EditorView | null>(null);
  // New state for expanded warnings
  const [showWarningsExpanded, setShowWarningsExpanded] =
    useState<boolean>(false);

  // State to track container height for matching
  const [leftContainerHeight, setLeftContainerHeight] = useState<number>(500);

  // Sync questionModelList and currentIndex to refs to avoid closure issues in heartbeat
  useEffect(() => {
    questionModelListRef.current = questionModelList;
    Logger.info(
      "questionModelListRef updated - length:",
      questionModelList.length,
    );
  }, [questionModelList]);

  useEffect(() => {
    currentIndexRef.current = currentIndex;
    Logger.info("currentIndexRef updated:", currentIndex);
  }, [currentIndex]);

  const getLanguageColor = (language: string) => {
    switch ((language || "").toLowerCase()) {
      case "python":
        return "#3776AB";
      case "java":
        return "#007396";
      case "javascript":
      case "js":
        return "#F7DF1E";
      default:
        return "#667eea";
    }
  };

  const isProgrammingQuestion = (q?: QuestionListModel | null) => {
    if (!q) return false;

    // Check userInput first (most reliable)
    if (q.userInput === UserInput.programming) {
      return true;
    }

    // Check explicit questionType string
    if (q.questionType && q.questionType.toLowerCase() === "programming") {
      return true;
    }

    return false;
  };

  //------Functions

  //Heart Beat API Start functions
  const heartBeatStartTimer = () => {
    Logger.info(
      "heartBeatStartTimer called at",
      new Date().toLocaleTimeString(),
    );
    if (!heartBeatTimerRef.current) {
      Logger.info("Creating new HeartBeatTimer instance");
      heartBeatTimerRef.current = new HeartBeatTimer(
        fetchHeartBeatApiData,
        10000,
      );
    }
    heartBeatTimerRef.current.start();
    Logger.info("HeartBeatTimer started");
    setHeartBeartRunning(true);
  };

  //HeartApi pause the timer
  const heartBeatPauseTimer = () => {
    Logger.info("Heart beat API paused at", new Date().toLocaleTimeString());

    if (heartBeatTimerRef.current) {
      heartBeatTimerRef.current.pause();
    }
    setHeartBeartRunning(false);
  };

  //Reset Heart Beat Timer
  const resetHeartBeatTimer = () => {
    if (heartBeatTimerRef.current) {
      heartBeatTimerRef.current.reset();
    }
    setHeartBeatApiResponse(null);
    setHeartBeartRunning(false);
  };

  // Effect to monitor isChildWindowOpen state
  useEffect(() => {
    if (!isChildWindowOpen) {
      heartBeatPauseTimer();
    }
  }, [isChildWindowOpen]);

  useEffect(() => {
    //Log Analytics Assessment Page
    logPageView(analytics_strings.analytics_path.assessmentQuestionPage);
    return () => {
      heartBeatPauseTimer(); // heartbeat timer Stop  when the component unmounts
      dispatch(clearAssessment());
      LocalStorage.removeLocalData("elapsedTime");
    };
  }, []);

  // Get local duration from localStorage, parse it as a number
  const localDuration = parseInt(
    LocalStorage.getLocalData(
      strings.localStorage_keys.assessment_details.duration,
    ) || "0",
    10,
  );
  // Add these refs near your other refs
  const codeContentRef = useRef<string>("");
  const selectedProgrammingLanguageRef = useRef<string>("Python");
  // Sync codeContent to ref
  useEffect(() => {
    codeContentRef.current = codeContent;
  }, [codeContent]);

  // Sync selectedProgrammingLanguage to ref
  useEffect(() => {
    selectedProgrammingLanguageRef.current = selectedProgrammingLanguage;
  }, [selectedProgrammingLanguage]);
  //HeartBeat ApiCall - For all questions
  const fetchHeartBeatApiData = async () => {
    Logger.info(
      "fetchHeartBeatApiData triggered at",
      new Date().toLocaleTimeString(),
    );
    api.setAuthToken(LocalStorage.getLocalData("access_token"));
    try {
      const questionList = questionModelListRef.current;
      const index = currentIndexRef.current;
      Logger.info(
        "fetchHeartBeatApiData - using refs - questionList.length:",
        questionList.length,
        "currentIndex:",
        index,
      );

      if (questionList.length === 0) {
        Logger.info(
          "fetchHeartBeatApiData - no questions loaded yet; skipping heartbeat",
        );
        return;
      }

      const currentQ = questionList[index];
      const isProgammingQuestion = isProgrammingQuestion(currentQ);
      Logger.info(
        "Current question type:",
        currentQ?.questionType,
        "userInput:",
        currentQ?.userInput,
        "programming_languages:",
        currentQ?.programming_languages,
        "Is Programming:",
        isProgammingQuestion,
        "Index:",
        index,
        "QuestionList length:",
        questionList.length,
      );

      // Always call heartbeat API
      const assessmentId = LocalStorage.getLocalData(
        strings.localStorage_keys.assessment_details.assessment_id,
      );
      const elapsedTime = LocalStorage.getLocalData("elapsedTime");
      Logger.info(
        "Heartbeat API params - assessmentId:",
        assessmentId,
        "elapsedTime:",
        elapsedTime,
      );
      Logger.info("Calling heartbeat API");

      await api
        .post<Heartbeat>(
          `${
            AssessmentQuestionModuleClient.heart_beat
          }?assessment_id=${assessmentId}&time_spend=${elapsedTime}`,
        )
        .then((res) => {
          Logger.info("Heartbeat API response success:", res);
        })
        .catch((error) => {
          Logger.info("error response from heartbeat", error);
        });

      // Additionally, for programming questions also call saveProgrammingCode
      if (isProgammingQuestion && codeContentRef.current) {
        Logger.info("Calling saveProgrammingCode for programming question");
        await saveProgrammingCode();
      }
    } catch (error) {
      Logger.info("fetchHeartBeatApiData caught error:", error);
    } finally {
    }
  };

  //Reset PerQuestionStartTime to Now
  const resetStartTimePerQuestions = () => {
    setStartTimePerQuestions(new Date());
  };
  //Check Status Function
  const checkStatus = () => {
    const candidateStatus = LocalStorage.getLocalData(
      strings.localStorage_keys.assessment_details.candidate_assessment_status,
    );
    Logger.info(
      "checkStatus - candidate_assessment_status:",
      candidateStatus,
      "totalQuestions (from localStorage):",
      totalQuestions,
    );

    if (candidateStatus === strings.assessment_status.inProgress) {
      //Resume Assessment
      fetchResumedQuestionCall();
    } else {
      //Start Assessment
      // If totalQuestions is 0 (missing in localStorage), still attempt to fetch the first question
      if (totalQuestions <= 0) {
        Logger.info(
          "totalQuestions is 0 or missing; attempting to fetch first question anyway",
        );
      }
      fetchQuestionCall(1);
    }
  };

  //Save Programming Code API Call (separate from heartbeat)
  const saveProgrammingCode = async () => {
    Logger.info("Save code API called at", new Date().toLocaleTimeString());
    api.setAuthToken(LocalStorage.getLocalData("access_token"));
    try {
      const questionList = questionModelListRef.current;
      const index = currentIndexRef.current;
      const currentQ = questionList[index];
      const isProgammingQuestion = isProgrammingQuestion(currentQ);
      Logger.info(
        "saveProgrammingCode - using refs - currentQ type:",
        currentQ?.questionType,
        "userInput:",
        currentQ?.userInput,
        "programming_languages:",
        currentQ?.programming_languages,
        "Is Programming:",
        isProgammingQuestion,
        "codeContent length:",
        codeContent.length,
      );

      if (isProgammingQuestion) {
        const payload = {
          assessment_id: LocalStorage.getLocalData(
            strings.localStorage_keys.assessment_details.assessment_id,
          ),
          dimension_id: currentQ!.dimensionId,
          question_id: currentQ!.questionId,
          submitted_programming_language:
            currentQ!.submitted_programming_language ||
            selectedProgrammingLanguage,
          // Use draft_code instead of submitted_code
          draft_code: currentQ!.draft_code || codeContentRef.current,
        };

        Logger.info("Posting to save_code API with payload:", payload);
        await api
          .post(AssessmentQuestionModuleClient.save_code, payload)
          .then((res) => {
            Logger.info("save_code API response:", res.data);
          })
          .catch((error) => {
            Logger.info("save_code error response", error);
          });
      } else {
        Logger.info(
          "saveProgrammingCode - Not a programming question or currentQ is null",
        );
      }
    } catch (error) {
      Logger.info("save_code error", error);
    }
  };

  useEffect(() => {
    heartBeatStartTimer();
  }, []);
  const [isQuestionLoading, setIsQuestionLoading] = useState(false);
  //Fetch Next Question API Call
  const fetchQuestionCall = async (questionNo: number) => {
    if (questionNo <= totalQuestions) {
      // Show loader only for Question No. 1
      if (questionNo === 1) {
        setIsQuestionLoading(true);
      }
      await questionModuleApiService
        .fetchQuestions(questionNo)
        .then((questions) => {
          Logger.info("fetchQuestionCall - API response:", questions);
          if (questionNo != 1) {
            timerRef.current.resume(); //resume the UI timer
            heartBeatStartTimer();
          }
          if (!questions?.item && questions?.error !== null) {
            showAlert({
              identity: "",
              show: true,
              title: "Errors",
              message: questions?.error,
              alertType: "error",
              onlyNeedOneButton: true,
              button1Text: "OK",
              btn1onPressed: () => {},
            });
          } else {
            resetStartTimePerQuestions();
            if (questions.item?.question.question_audio) {
              // Initialize Audio
            }
            assignQuestionModel(questions?.item!);
            setCurrentIndex(questionNo - 1);
            //Clear the Previous Selected Answers
            setSelectedAnswerId(null);
            setDescriptiveText("");
          }
          // heartBeatStartTimer();
        })
        .catch((e) => {})
        .finally(() => {
          setIsQuestionLoading(false);
        });
    }
  };
  //Fetch Resume Question API Call
  const fetchResumedQuestionCall = async () => {
    setIsQuestionLoading(true);
    await questionModuleApiService
      .fetchResumedStatePrevQuestions()
      .then((prev_question) => {
        Logger.info("fetchResumedQuestionCall - API response:", prev_question);
        resetHeartBeatTimer();
        if (prev_question && prev_question?.previous_questions.length !== 0) {
          const sortedPrevQuestions = [
            ...prev_question.previous_questions,
          ].sort((a, b) => a.seq_number - b.seq_number);
          resetStartTimePerQuestions();
          sortedPrevQuestions.forEach((item, index) => {
            Logger.info("assigning resumed question seq:", item.seq_number);
            if (item.question.question_audio) {
              //Initialize Question Auido
            }
            assignQuestionModel(item);
            if (index === sortedPrevQuestions.length - 1) {
              Logger.info(
                "Resume complete, fetching next question and restarting heartbeat",
              );
              fetchQuestionCall(prev_question.next_seq_number);
              // // Restart heartbeat timer after resume is complete
              // heartBeatStartTimer();
            }
          });
        } else {
          if (prev_question?.previous_questions.length === 0) {
            //If First Question is UnAttended
            Logger.info(
              "No previous questions, fetching first question and restarting heartbeat",
            );
            fetchQuestionCall(1);
            // heartBeatStartTimer();
          } else {
            showAlert({
              identity: "",
              show: true,
              title: "Error",
              message: "Something went wrong in resume api",
              alertType: "error",
              onlyNeedOneButton: true,
              button1Text: "OK",
              btn1onPressed: () => {},
            });
          }
        }
      })
      .catch((e) => {})
      .finally(() => {
        setIsQuestionLoading(false);
      });
  };
  //AssignModel
  const assignQuestionModel = (success: Item) => {
    Logger.info(
      "assignQuestionModel - constructing question from API item:",
      success,
    );

    // Determine which code to use - priority: submitted_code > draft_code
    let initialCode = "";
    const hasSubmittedCode = (success.question as any).submitted_code;
    const hasDraftCode = (success.question as any).draft_code;

    if (hasSubmittedCode) {
      initialCode = hasSubmittedCode;
      Logger.info(
        "Using submitted_code for question:",
        success.question.question_id,
      );
    } else if (hasDraftCode) {
      initialCode = hasDraftCode;
      Logger.info(
        "Using draft_code for question:",
        success.question.question_id,
      );
    }

    // Log the actual values for debugging
    Logger.info("submitted_code value:", hasSubmittedCode);
    Logger.info("draft_code value:", hasDraftCode);
    Logger.info("initialCode set to:", initialCode.substring(0, 50) + "...");

    const data: QuestionListModel = {
      questionId: success.question.question_id,
      questionNumber: success.seq_number.toString(),
      question: success.question.question,
      questionType: success.question.question_type,
      selected: success.seq_number === 1,
      questionAudio: success.question.question_audio,
      dimensionId: success.dimension_id,
      saved:
        success.question.answer_selected !== undefined ||
        success.question.answer_selected !== null,
      showFlag: success.question.flag_selected,
      typedAnswer:
        success.question.question_type === UserInput.descriptive
          ? success.question.answer_selected
          : "",
      optionModelList:
        success.question.question_type !==
        strings.assessment_questiontype.descriptive
          ? [
              {
                selected:
                  success.question.answer_selected !== undefined &&
                  success.question.response_option_1?.answer_id ===
                    success.question.answer_selected,
                optionText: success.question.response_option_1?.answer,
                optionNumber: "A",
                optionKey: success.question.response_option_1?.answer_id,
              },
              {
                selected:
                  success.question.answer_selected !== undefined &&
                  success.question.response_option_2?.answer_id ===
                    success.question.answer_selected,
                optionText: success.question.response_option_2?.answer,
                optionNumber: "B",
                optionKey: success.question.response_option_2?.answer_id,
              },
              {
                selected:
                  success.question.answer_selected !== undefined &&
                  success.question.response_option_3?.answer_id ===
                    success.question.answer_selected,
                optionText: success.question.response_option_3?.answer,
                optionNumber: "C",
                optionKey: success.question.response_option_3?.answer_id,
              },
              {
                selected:
                  success.question.answer_selected !== undefined &&
                  success.question.response_option_4?.answer_id ===
                    success.question.answer_selected,
                optionText: success.question.response_option_4?.answer,
                optionNumber: "D",
                optionKey: success.question.response_option_4?.answer_id,
              },
            ]
          : [],
      questionMedia: success.question.question_media,
      questionMediaUrls: success.question.question_media_urls,
      // map programming-specific fields if present on the response
      problem_statement: (success.question as any).problem_statement || null,
      programming_languages:
        (success.question as any).programming_languages ||
        (success.question as any).programming_language ||
        null,
      instructions: (success.question as any).instructions || null,
      submitted_programming_language:
        (success.question as any).submitted_programming_language || null,
      // Store both submitted_code and draft_code
      submitted_code: (success.question as any).submitted_code || null,
      draft_code: (success.question as any).draft_code || null,
    };

    Logger.info("assignQuestionModel - mapped data:", data);
    setQuestionModelList((prevList) => {
      Logger.info(
        "assignQuestionModel - previous list length:",
        prevList.length,
      );
      const existingQuestion = prevList.find(
        (item) => item.questionId === success.question.question_id,
      );
      if (existingQuestion) return prevList;

      const updatedList = [...prevList, data];
      return updatedList;
    });
  };

  const onOptionSelected = (option: OptionModel) => {
    //To freeze optionchange on save
    if (isLoading) {
      return;
    }
    if (questionModelList && currentIndex !== undefined) {
      if (option.optionKey === selectedAnswerId) {
        //UnSelect
        setSelectedAnswerId(null);
        //Locally Save the Last UnSelected Option & Enable Save Button
        const updatedQuestions = questionModelList.map((question, index) =>
          index === currentIndex &&
          (question.questionType === UserInput.multiChoice ||
            question.questionType === UserInput.imageType)
            ? {
                ...question,
                optionModelList:
                  currentIndex === questionModelList.length - 1
                    ? question.optionModelList.map((opt) => ({
                        ...opt,
                        selected: false,
                      }))
                    : question.optionModelList,
                saved: false,
              }
            : question,
        );
        setQuestionModelList(updatedQuestions);
      } else {
        //Select
        option.optionKey && setSelectedAnswerId(option.optionKey);
        //Locally Save the Last Selected Option & Enable Save Button
        const updatedQuestions = questionModelList.map((question, index) =>
          index === currentIndex &&
          (question.questionType === UserInput.multiChoice ||
            question.questionType === UserInput.imageType)
            ? {
                ...question,
                optionModelList:
                  currentIndex === questionModelList.length - 1
                    ? question.optionModelList.map((opt) => ({
                        ...opt,
                        selected: opt.optionKey === option.optionKey,
                      }))
                    : question.optionModelList,
                saved: false,
              }
            : question,
        );
        setQuestionModelList(updatedQuestions);
      }
    }
  };
  const onDescriptiveOptionChange = (value: string) => {
    setDescriptiveText(value);
    //Locally Save the Last Selected Option & Enable Save Button
    if (currentIndex === questionModelList.length - 1) {
      const updatedQuestions = questionModelList.map((question, index) =>
        index === currentIndex &&
        question.questionType === UserInput.descriptive
          ? {
              ...question,
              typedAnswer: value ?? "",
              saved: false,
            }
          : question,
      );
      setQuestionModelList(updatedQuestions);
    } else {
      // Enable Save Button
      const updatedQuestions = questionModelList.map((question, index) =>
        index === currentIndex &&
        question.questionType === UserInput.descriptive
          ? {
              ...question,
              saved: false,
            }
          : question,
      );
      setQuestionModelList(updatedQuestions);
    }
  };
  //Update Selected Answer while Forward & Backward & onTap
  const onQuestionChangeSetSelectedAnswer = (index: number) => {
    const currentQ = questionModelList[index];

    if (currentQ.questionType === UserInput.descriptive) {
      setSelectedAnswerId(null);
      //Set the Selected Answer for Descriptive
      setDescriptiveText(currentQ.typedAnswer ?? "");
    } else if (isProgrammingQuestion(currentQ)) {
      // Set code and language for programming question
      setSelectedAnswerId(null);

      // Priority: submitted_code > draft_code, but make sure to check both
      let codeToLoad = "";

      if (currentQ.submitted_code) {
        codeToLoad = currentQ.submitted_code;
        Logger.info(
          "Loading submitted_code for question:",
          currentQ.questionId,
        );
      } else if (currentQ.draft_code) {
        codeToLoad = currentQ.draft_code;
        Logger.info("Loading draft_code for question:", currentQ.questionId);
      }

      // Always set the code content, even if it's empty
      setCodeContent(codeToLoad);
      Logger.info("Set codeContent to:", codeToLoad.substring(0, 50) + "...");

      // prefer submitted language, else pick first from programming_languages
      if (currentQ.submitted_programming_language) {
        setSelectedProgrammingLanguage(currentQ.submitted_programming_language);
      } else if (currentQ.programming_languages) {
        const langs = currentQ.programming_languages
          .split(",")
          .map((l) => l.trim());
        if (langs.length > 0) setSelectedProgrammingLanguage(langs[0]);
      }
    } else {
      setDescriptiveText(null); //Before Assign Selected Answer Clear All
      //Set the Selected Answer for MultiChoice
      const selectedOption = currentQ?.optionModelList.find(
        (opt) => opt.selected === true,
      );

      if (selectedOption?.optionKey) {
        setSelectedAnswerId(selectedOption.optionKey);
      } else {
        setSelectedAnswerId(null); // Explicitly set to null if no option is selected
      }
    }
  };

  const runCode = async () => {
    try {
      setIsRunningCode(true);
      setRunOutput(null);
      api.setAuthToken(LocalStorage.getLocalData("access_token"));
      const payload = {
        code_content: codeContent,
        programming_language: selectedProgrammingLanguage,
      };
      const res = await api.post("/programming/run", payload);
      setRunOutput(res.data);
    } catch (err: any) {
      setRunOutput({ stdout: "", stderr: err?.message || "Error" });
    } finally {
      setIsRunningCode(false);
    }
  };

  const clearEnableSaveStateButton = () => {
    // Only change the save state for the current question
    const updatedQuestions = questionModelList.map((question, inDx) =>
      inDx === currentIndex
        ? {
            ...question,
            saved: true,
          }
        : question,
    );
    setQuestionModelList(updatedQuestions);
  };

  const onProgrammingCodeChange = (value: string) => {
    setCodeContent(value);
    if (currentIndex === questionModelList.length - 1) {
      const updatedQuestions = questionModelList.map((question, index) =>
        index === currentIndex && isProgrammingQuestion(question)
          ? {
              ...question,
              submitted_code: value ?? "",
              saved: false,
            }
          : question,
      );
      setQuestionModelList(updatedQuestions);
    } else {
      const updatedQuestions = questionModelList.map((question, index) =>
        index === currentIndex && isProgrammingQuestion(question)
          ? {
              ...question,
              saved: false,
            }
          : question,
      );
      setQuestionModelList(updatedQuestions);
    }
  };

  const onProgrammingLanguageChange = (lang: string) => {
    setSelectedProgrammingLanguage(lang);
    const updatedQuestions = questionModelList.map((question, index) =>
      index === currentIndex && isProgrammingQuestion(question)
        ? {
            ...question,
            submitted_programming_language: lang,
            saved: false,
          }
        : question,
    );
    setQuestionModelList(updatedQuestions);
  };
  //To Submit the Assessment
  const submitAssessmentApiCall = async () => {
    logActionEvent(analytics_strings.analytics_events.submitButton, {
      candidate_id: userData.candidate_id,
    });
    await questionModuleApiService
      .submitAssessment()
      .then((response) => {
        if (response?.detail) {
          setIsFeedbackFormVisible(true);
          heartBeatPauseTimer();
          questionModuleApiService.clearAssessmentLocalStorage();
        } else {
          response?.error && setIsErrorMsgPopup(response?.error);
          setIsLoading(false);
        }
      })
      .catch((e) => {})
      .finally(() => {
        setIsReviewErrorPopup(false);
      });
  };

  useEffect(() => {
    if (!isTimeUp) return;

    handleSaveNextSubmit(true);
    setIsTimeUp(false);
  }, [isTimeUp]);

  const handleSaveNextSubmit = async (isAssessmentTimeEnds?: boolean) => {
    //Review Skill Prevented for If Timer Expires
    if (!isAssessmentTimeEnds) {
      const anyReviewFlagTrue = questionModelList.some(
        (question) => question.showFlag,
      );
      if (
        anyReviewFlagTrue &&
        currentIndex + 1 === totalQuestions &&
        isReviewErrorPopup !== true
      ) {
        //Checking that IsFlag is Enabled
        setIsReviewErrorPopup(true);
        return;
      }
    }
    setIsLoading(true);
    if (
      // currentIndex + 1 === totalQuestions &&
      (questionModelList[currentIndex]?.questionType ===
        UserInput.descriptive &&
        descriptiveText?.trim() === "") ||
      ((questionModelList[currentIndex]?.questionType ===
        UserInput.multiChoice ||
        questionModelList[currentIndex]?.questionType ===
          UserInput.imageType) &&
        questionModelList[currentIndex]?.optionModelList.every(
          (option) => option.selected === false,
        ))
    ) {
      //Submit LastQuestion Without Answer Selected
      submitAssessmentApiCall();
      return;
    }
    //Timer ui increamented because timeSpend is 1
    if (CommonUtils.utilityTimeForEachQuestion(startTimePerQuestions!) === 1) {
      timerRef.current?.decrement(1);
      heartBeatTimerRef.current?.decrement(1);
    } else {
      timerRef.current.pause(); //Pause the UI timer
      heartBeatPauseTimer();
    }
    const param: AssessmentAnswerRequest = {
      ...(questionModelList[currentIndex!].questionType !==
      UserInput.programming
        ? {
            answer_selected:
              questionModelList[currentIndex!].questionType ===
              UserInput.descriptive
                ? descriptiveText!
                : selectedAnswerId!,
          }
        : {}),
      time_spend: CommonUtils.utilityTimeForEachQuestion(
        startTimePerQuestions!,
      ),
      question_id: questionModelList[currentIndex!].questionId!,
      dimension_id: questionModelList[currentIndex!].dimensionId!,
      assessment_id: LocalStorage.getLocalData(
        strings.localStorage_keys.assessment_details.assessment_id,
      )!,
      flag_selected: questionModelList[currentIndex!].showFlag!,
      // If programming question include the submitted language & code
      ...(questionModelList[currentIndex!].questionType ===
      UserInput.programming
        ? {
            submitted_programming_language:
              questionModelList[currentIndex!].submitted_programming_language ||
              selectedProgrammingLanguage,
            // When submitting final answer, use submitted_code
            submitted_code:
              questionModelList[currentIndex!].submitted_code || codeContent,
            // // Also include draft_code for the save_code API to use
            // draft_code: codeContent,
          }
        : {}),
    };
    await questionModuleApiService
      .saveAssessmentAnswer({ param: param })
      .then((answer_response) => {
        if (
          answer_response?.detail &&
          answer_response.next_seq_number &&
          !isAssessmentTimeEnds //Prevent Fetch Next Question on Timer Ends
        ) {
          //Save Successful so TO update saved Answer in Original List
          const updatedQuestions = questionModelList.map((question, index) =>
            question.questionId === param.question_id
              ? question.questionType === UserInput.multiChoice ||
                question.questionType === UserInput.imageType
                ? {
                    ...question,
                    optionModelList: question.optionModelList.map((opt) => ({
                      ...opt,
                      selected: opt.optionKey === param.answer_selected,
                    })),
                    saved: true,
                  }
                : {
                    ...question,
                    typedAnswer: param.answer_selected ?? "",
                    saved: true,
                  }
              : question,
          );
          setQuestionModelList(updatedQuestions);
          if (currentIndex !== totalQuestions - 1) {
            //Resetric fetch on Last Question
            //Fetch Next Question
            if (currentIndex === questionModelList.length - 1) {
              //Updating on Last  Question
              answer_response.next_seq_number &&
                fetchQuestionCall(answer_response.next_seq_number).then(() => {
                  setIsLoading(false);
                });
            } else {
              timerRef.current.resume(); //resume the UI timer
              heartBeatStartTimer();
              //Updating Answer on Already Fetched Question
              handleForward();
              setIsLoading(false);
            }
          }
        } else {
          if (currentIndex === totalQuestions - 1 || isAssessmentTimeEnds) {
            //Submit LastQuestion
            submitAssessmentApiCall();
          } else {
            //Error Popup
            answer_response?.detail &&
              setIsErrorMsgPopup(answer_response?.detail);
            answer_response?.error &&
              setIsErrorMsgPopup(answer_response?.error);
          }
        }
        //Timer stops on quick Answering
        // timerRef.current.resume(); //resume the UI timer
        // heartBeatStartTimer();
      })
      .catch((e) => {});
  };

  const assessmentLogout = async () => {
    logActionEvent(analytics_strings.analytics_events.assessmentLogoutButton, {
      candidate_id: userData.candidate_id,
    });
    Loader.showLoading("Loading...");
    api.setAuthToken(LocalStorage.getLocalData("access_token"));
    try {
      await api
        .post<LogOutResponse>(
          `${AssessmentQuestionModuleClient.logout}?assessment_id=${assessmentId}`,
        )
        .then((res) => {
          if (res?.data?.error === null) {
            handleShowNotification(
              "You have been logged out of the assessment.",
            );
            setTimeout(() => {
              questionModuleApiService.clearAssessmentLocalStorage();
              dispatch(clearAssessment());
              heartBeatPauseTimer();
              setIsChildWindowOpen(false);
              navigate("/dashboard/student");
            }, 1000);
          }
        })
        .catch((error) => {
          Logger.info("error response", error);
        });
    } catch (error) {
      Logger.info("error response", error);
    } finally {
      Loader.dismissLoading();
    }
  };

  //Update the Question While Tap on Bubble
  const setCurrentQuestionTab = (index: number) => {
    setCurrentIndex(index);
    onQuestionChangeSetSelectedAnswer(index);
    clearEnableSaveStateButton();
  };
  //Update the Question While Forward
  const handleForward = async () => {
    if (!(currentIndex >= questionModelList.length - 1)) {
      const nextIndex = currentIndex + 1;
      setCurrentIndex(nextIndex);
      onQuestionChangeSetSelectedAnswer(nextIndex);
    }
  };
  //Update the Question While Backward
  const handlePrevious = () => {
    if (currentIndex > 0) {
      const prevIndex = currentIndex - 1;
      setCurrentIndex(prevIndex);
      onQuestionChangeSetSelectedAnswer(prevIndex);
    }
  };
  //Update the ReviewFlag for current question
  const handleReviewFlag = () => {
    setQuestionModelList((prevQuestions) => {
      const updatedQuestions = [...prevQuestions];
      if (currentIndex >= 0 && currentIndex < updatedQuestions.length) {
        updatedQuestions[currentIndex] = {
          ...updatedQuestions[currentIndex],
          showFlag: !updatedQuestions[currentIndex].showFlag,
        };
      }
      return updatedQuestions;
    });
  };
  //Snackbar success while logout button used
  const handleShowNotification = (msg: string) => {
    setShowNotification(msg);
  };

  const handleCloseNotification = () => {
    setShowNotification(null);
  };
  // Validate code based on language
  const validateCode = (code: string, language: string) => {
    let result: ValidationResult;

    switch (language.toLowerCase()) {
      case "python":
        result = validatePythonCode(code);
        break;
      case "javascript":
      case "js":
        result = validateJavaScriptCode(code);
        break;
      case "java":
        result = validateJavaCode(code);
        break;
      default:
        result = { isValid: true, errors: [], warnings: [] };
    }

    setValidationResult(result);
    return result;
  };

  // Handle code change with validation
  const handleCodeChange = (value: string) => {
    setCodeContent(value);

    // Validate code after a small delay to avoid too frequent validation
    if (showValidation) {
      const timeoutId = setTimeout(() => {
        validateCode(value, selectedProgrammingLanguage);
      }, 500);

      return () => clearTimeout(timeoutId);
    }

    // Update question model
    if (currentIndex === questionModelList.length - 1) {
      const updatedQuestions = questionModelList.map((question, index) =>
        index === currentIndex && isProgrammingQuestion(question)
          ? {
              ...question,
              submitted_code: value ?? "",
              saved: false,
            }
          : question,
      );
      setQuestionModelList(updatedQuestions);
    } else {
      const updatedQuestions = questionModelList.map((question, index) =>
        index === currentIndex && isProgrammingQuestion(question)
          ? {
              ...question,
              saved: false,
            }
          : question,
      );
      setQuestionModelList(updatedQuestions);
    }
  };

  useEffect(() => {
    const totalOptionsHeight = optionRefs.current.reduce((total, ref) => {
      return total + (ref ? ref.clientHeight : 0);
    }, 0);

    // Assuming a margin of 10px between options
    const marginBetweenOptions =
      10 *
      ((questionModelList?.[currentIndex]?.optionModelList?.length || 0) - 1);

    setQuestionHeight(totalOptionsHeight + marginBetweenOptions + 60);
    if (
      questionModelList[currentIndex]?.questionType === UserInput.descriptive
    ) {
      setQuestionHeight(400);
    }
  }, [currentIndex, questionModelList]);

  useEffect(() => {
    checkStatus();
  }, []);

  const [showTooltip, setShowTooltip] = useState(false);

  // Add this useEffect to update editor content when currentIndex changes
  useEffect(() => {
    const currentQ = questionModelList[currentIndex];
    if (currentQ && isProgrammingQuestion(currentQ)) {
      // Force update of code content when question changes
      // Priority: submitted_code > draft_code
      let codeToLoad = "";

      if (currentQ.submitted_code) {
        codeToLoad = currentQ.submitted_code;
        Logger.info(
          "useEffect - Loading submitted_code for question:",
          currentQ.questionId,
        );
      } else if (currentQ.draft_code) {
        codeToLoad = currentQ.draft_code;
        Logger.info(
          "useEffect - Loading draft_code for question:",
          currentQ.questionId,
        );
      }

      setCodeContent(codeToLoad);
      Logger.info("useEffect - Set codeContent to length:", codeToLoad.length);

      if (currentQ.submitted_programming_language) {
        setSelectedProgrammingLanguage(currentQ.submitted_programming_language);
      } else if (currentQ.programming_languages) {
        const langs = currentQ.programming_languages
          .split(",")
          .map((l) => l.trim());
        if (langs.length > 0) setSelectedProgrammingLanguage(langs[0]);
      }
      // Run validation on the loaded code
      if (codeToLoad) {
        const result = validateCode(
          codeToLoad,
          currentQ.submitted_programming_language ||
            currentQ.programming_languages?.split(",")[0]?.trim() ||
            "Python",
        );
        setValidationResult(result);
      }
    }
  }, [currentIndex, questionModelList]);

  // Effect to measure left container height
  useEffect(() => {
    if (questionContainerRef.current) {
      const height = questionContainerRef.current.clientHeight;
      setLeftContainerHeight(height);
    }
  }, [currentIndex, questionModelList, questionHeight]);

  const getTooltipMessage = () => {
    const currentLang = selectedProgrammingLanguage.toLowerCase();
    switch (currentLang) {
      case "python":
        return "⚠️ Runtime input (input()) is not supported";
      case "javascript":
      case "js":
        return "⚠️ Runtime input (prompt()) is not supported";
      case "java":
        return "⚠️ Runtime input (Scanner, System.console) is not supported";
      default:
        return "⚠️ Runtime input is not supported";
    }
  };

  // Programming Toolbar - Inside left container with compact design
  const renderProgrammingToolbar = () => {
    return (
      <div
        style={{
          display: "flex",
          gap: "6px",
          padding: "6px 12px",
          backgroundColor: "#f5f5f5",
          borderBottom: "1px solid #ddd",
          alignItems: "center",
          flexWrap: "wrap",
          width: "100%",
        }}
      >
        <div
          style={{
            flex: 1,
            minWidth: "50px", // Reduced from 100px
            display: "flex",
            alignItems: "center",
            gap: "4px",
          }}
        >
          <select
            // className="codehub-select"
            value={selectedProgrammingLanguage}
            onChange={(e) => {
              onProgrammingLanguageChange(e.target.value);
              setValidationResult(null);
            }}
            style={{
              borderColor: getLanguageColor(selectedProgrammingLanguage),
              padding: "4px 6px",
              borderRadius: 4,
              fontSize: "12px",
              width: "100px", // Fixed width for dropdown
            }}
          >
            {(questionModelList[currentIndex].programming_languages || "Python")
              .split(",")
              .map((l) => l.trim())
              .filter((l) => l.length > 0)
              .map((lang, idx) => (
                <option key={idx} value={lang}>
                  {lang}
                </option>
              ))}
          </select>

          {/* Info Icon with Tooltip */}
          <div
            style={{
              position: "relative",
              display: "flex",
              alignItems: "center",
            }}
            onMouseEnter={() => setShowTooltip(true)}
            onMouseLeave={() => setShowTooltip(false)}
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style={{ cursor: "help", color: "#666" }}
            >
              <circle
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="1.5"
              />
              <path
                d="M12 8V12"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
              />
              <circle
                cx="12"
                cy="16"
                r="0.5"
                fill="currentColor"
                stroke="currentColor"
                strokeWidth="1.5"
              />
            </svg>

            {showTooltip && (
              <div
                style={{
                  position: "absolute",
                  top: "100%",
                  left: "50%",
                  transform: "translateX(-50%)",
                  marginTop: "4px",
                  backgroundColor: "#333",
                  color: "white",
                  padding: "4px 8px",
                  borderRadius: "4px",
                  fontSize: "11px",
                  whiteSpace: "nowrap",
                  zIndex: 1000,
                  boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
                }}
              >
                {getTooltipMessage()}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };

  // Enhanced programming section with CodeMirror
  const renderProgrammingEditor = () => {
    return (
      <div style={{ height: "100%", display: "flex", flexDirection: "column" }}>
        {/* CodeMirror Editor - Fixed to prevent double scroll */}
        <div
          style={{
            position: "relative",
            width: "100%",
            borderLeft:
              validationResult?.errors && validationResult.errors.length > 0
                ? "3px solid #f44336"
                : validationResult?.warnings &&
                    validationResult.warnings.length > 0
                  ? "3px solid #ff9800"
                  : "3px solid #c8c8c8",
            borderRight: "3px solid #c8c8c8",
            borderBottom: "none",
            borderTop: "3px solid #c8c8c8",
            backgroundColor: "#1e1e1e",
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
            flex: 1,
            minHeight: 0, // Important for flex children
          }}
        >
          {/* Editor container - Takes available space */}
          <div
            style={{
              flex: 1,
              minHeight: 0, // Important for flex children
              overflow: "auto",
            }}
          >
            <CodeMirror
              key={`editor-${currentIndex}-${selectedProgrammingLanguage}`}
              value={codeContent}
              height="100%"
              theme={oneDark}
              extensions={[
                getLanguageExtension(selectedProgrammingLanguage),
                keymap.of([indentWithTab]),
                autocompletion(),
                EditorView.lineWrapping,
                EditorView.theme({
                  "&": {
                    height: "100%",
                    fontSize: "13px",
                    fontFamily: "'Mazzard', monospace",
                  },
                  ".cm-scroller": {
                    overflow: "auto",
                  },
                  ".cm-content": {
                    padding: "10px 0",
                  },
                  ".cm-line": {
                    padding: "0 4px",
                  },
                }),
              ]}
              onChange={(value: string) => {
                setCodeContent(value);
                const result = validateCode(value, selectedProgrammingLanguage);
                setValidationResult(result);

                if (currentIndex === questionModelList.length - 1) {
                  const updatedQuestions = questionModelList.map(
                    (question, index) =>
                      index === currentIndex && isProgrammingQuestion(question)
                        ? {
                            ...question,
                            submitted_code: value ?? "",
                            saved: false,
                          }
                        : question,
                  );
                  setQuestionModelList(updatedQuestions);
                } else {
                  const updatedQuestions = questionModelList.map(
                    (question, index) =>
                      index === currentIndex && isProgrammingQuestion(question)
                        ? {
                            ...question,
                            saved: false,
                          }
                        : question,
                  );
                  setQuestionModelList(updatedQuestions);
                }
              }}
              basicSetup={{
                lineNumbers: true,
                highlightActiveLineGutter: true,
                highlightSpecialChars: true,
                history: true,
                foldGutter: true,
                drawSelection: true,
                dropCursor: true,
                allowMultipleSelections: true,
                indentOnInput: true,
                syntaxHighlighting: true,
                bracketMatching: true,
                closeBrackets: true,
                autocompletion: true,
                rectangularSelection: true,
                crosshairCursor: true,
                highlightActiveLine: true,
                highlightSelectionMatches: true,
                closeBracketsKeymap: true,
                defaultKeymap: true,
                searchKeymap: true,
                historyKeymap: true,
                foldKeymap: true,
                completionKeymap: true,
              }}
            />
          </div>

          {/* Validation Status - Clickable to expand warnings */}
          {validationResult &&
            (validationResult.errors.length > 0 ||
              validationResult.warnings.length > 0) && (
              <div
                style={{
                  padding: "4px 8px",
                  backgroundColor:
                    validationResult.errors.length > 0 ? "#ffebee" : "#fff3e0",
                  borderTop: `1px solid ${validationResult.errors.length > 0 ? "#f44336" : "#ff9800"}`,
                  fontSize: 11,
                  cursor: "pointer",
                  flexShrink: 0,
                  maxHeight: showWarningsExpanded ? "200px" : "auto",
                  overflowY: showWarningsExpanded ? "auto" : "visible",
                }}
                onClick={() => setShowWarningsExpanded(!showWarningsExpanded)}
              >
                <div style={{ display: "flex", gap: 12, alignItems: "center" }}>
                  {validationResult.errors.length > 0 && (
                    <span style={{ color: "#f44336" }}>
                      ⚠ {validationResult.errors.length} error
                      {validationResult.errors.length !== 1 ? "s" : ""}
                    </span>
                  )}
                  {validationResult.warnings.length > 0 && (
                    <span style={{ color: "#ff9800" }}>
                      ⚠ {validationResult.warnings.length} warning
                      {validationResult.warnings.length !== 1 ? "s" : ""}
                    </span>
                  )}
                  <span
                    style={{
                      color: "#666",
                      marginLeft: "auto",
                      fontSize: "10px",
                    }}
                  >
                    {showWarningsExpanded ? "▼" : "▶"} Click to{" "}
                    {showWarningsExpanded ? "hide" : "show"} details
                  </span>
                </div>

                {/* Expanded warnings list with scroll */}
                {showWarningsExpanded && (
                  <div
                    style={{
                      marginTop: "8px",
                      padding: "8px",
                      backgroundColor: "rgba(0,0,0,0.02)",
                      borderRadius: "4px",
                      maxHeight: "150px",
                      overflowY: "auto",
                    }}
                  >
                    {validationResult.errors.length > 0 && (
                      <div
                        style={{
                          marginBottom:
                            validationResult.warnings.length > 0 ? "8px" : "0",
                        }}
                      >
                        <div
                          style={{
                            fontWeight: 600,
                            color: "#f44336",
                            marginBottom: "4px",
                            fontSize: "11px",
                          }}
                        >
                          Errors:
                        </div>
                        {validationResult.errors.map((error, idx) => (
                          <div
                            key={`error-${idx}`}
                            style={{
                              color: "#f44336",
                              fontSize: "11px",
                              marginLeft: "8px",
                              marginBottom: "2px",
                            }}
                          >
                            • {error}
                          </div>
                        ))}
                      </div>
                    )}
                    {validationResult.warnings.length > 0 && (
                      <div>
                        <div
                          style={{
                            fontWeight: 600,
                            color: "#ff9800",
                            marginBottom: "4px",
                            fontSize: "11px",
                          }}
                        >
                          Warnings:
                        </div>
                        {validationResult.warnings.map((warning, idx) => (
                          <div
                            key={`warning-${idx}`}
                            style={{
                              color: "#ff9800",
                              fontSize: "11px",
                              marginLeft: "8px",
                              marginBottom: "2px",
                            }}
                          >
                            • {warning}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                )}
              </div>
            )}
        </div>

        {/* Output Box - Fixed height */}
        <div
          style={{
            width: "100%",
            border: "3px solid #c8c8c8",
            borderTop: "none",
            backgroundColor: "#ffffff",
            padding: "10px",
            height: "120px", // Fixed height for output
            flexShrink: 0,
            overflowY: "auto",
            position: "relative",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "6px",
            }}
          >
            <div
              style={{
                fontWeight: 600,
                fontSize: "13px",
                color: "#1a1f24",
              }}
            >
              Output
            </div>
            <button
              className="codehub-btn codehub-btn-primary"
              onClick={() => runCode()}
              disabled={isRunningCode}
              style={{
                background: `linear-gradient(135deg, ${getLanguageColor(selectedProgrammingLanguage)} 0%, #764ba2 100%)`,
                padding: "4px 10px",
                border: "none",
                borderRadius: 4,
                color: "white",
                cursor: isRunningCode ? "not-allowed" : "pointer",
                fontSize: "12px",
                fontWeight: 500,
                whiteSpace: "nowrap",
              }}
            >
              {isRunningCode ? "Running..." : "Run"}
            </button>
          </div>
          <div className="codehub-output-block">
            {runOutput ? (
              runOutput.stdout || runOutput.stderr ? (
                <pre
                  className="codehub-output-text"
                  style={{
                    whiteSpace: "pre-wrap",
                    margin: 0,
                    fontSize: "12px",
                    color: runOutput.stderr ? "#d32f2f" : "#333",
                  }}
                >
                  {runOutput.stdout || runOutput.stderr}
                </pre>
              ) : (
                <pre
                  className="codehub-output-text"
                  style={{
                    whiteSpace: "pre-wrap",
                    margin: 0,
                    fontSize: "12px",
                    color: "#999",
                  }}
                >
                  {JSON.stringify(runOutput, null, 2)}
                </pre>
              )
            ) : (
              <pre
                style={{
                  margin: 0,
                  fontSize: "12px",
                  color: "#ccc",
                }}
              >
                Output will appear here
              </pre>
            )}
          </div>
        </div>
      </div>
    );
  };

  // if (questionModelList.length === 0) {
  //   return null;
  // }
  if (questionModelList.length === 0) {
    if (isQuestionLoading) {
      return <Loading message={"Loading..."} />;
    }

    return null;
  }
  const currentQuestion = questionModelList[currentIndex];
  const isProgramming = isProgrammingQuestion(currentQuestion);

  // Calculate appropriate height for containers
  const getContainerHeight = () => {
    if (isProgramming) {
      // For programming questions, use a fixed height that accommodates editor + output
      return "calc(100vh - 220px)"; // Adjust based on header and bottom bar
    } else if (currentQuestion?.questionType === UserInput.descriptive) {
      // For descriptive questions, use a reasonable height
      // return "550px";
      return "calc(90vh - 40%)";
    } else if (currentQuestion?.questionType === UserInput.imageType) {
      return "calc(90vh - 40%)";
    } else {
      // For multiple choice questions, use dynamic height based on options
      return `${questionHeight}px`;
    }
  };

  return (
    <div
      className="question-count-container"
      style={{
        backgroundColor: isDarkTheme ? "#242934" : "",
      }}
    >
      {/* Optimized Header - Equal margins on both sides with consistent top margin */}
      <div
        className="header-container-assessment"
        style={{
          backgroundColor: isDarkTheme ? "#0D0F14" : "",
        }}
      >
        {/* Left - Image */}
        {userData.logo_url ? (
          <img src={userData.logo_url} className="header-nojozuna-image"></img>
        ) : (
          <img src={JozunaLogo} alt="Logo" className="header-image" />
        )}
        {/* Center - Scroll Menu */}
        <AssessmentBubbleSelector
          currentIndex={currentIndex}
          fetchedQuestions={questionModelList}
          setCurrentQuestionTab={setCurrentQuestionTab}
          isDarkTheme={isDarkTheme}
        />
        {/* Right - Another Component */}
        <div
          className="right-end-component"
          style={{
            // marginRight: "12px",
            // position: "relative",
            display: "flex",
            alignContent: "center",
            justifyContent: "center",
          }}
        >
          <AssessmentTimer
            ref={timerRef}
            duration={totalDuration}
            onTimeUp={() => setIsTimeUp(true)}
          />
          {Boolean(cameraStream) &&
            (setupStep === "ready_to_start" || setupStep === "ready") && (
              <CameraPopup stream={cameraStream} />
            )}
          <img
            src={
              openMenu
                ? isDarkTheme
                  ? darkCancel
                  : cancelIcon
                : isDarkTheme
                  ? darkmenu
                  : hamburgerMenu
            }
            alt=""
            onClick={() => setOpenMenu((prev) => !prev)}
            style={{
              height: "50px",
              marginTop: "32px",
              width: "50px",
              cursor: "pointer",
            }}
          />
        </div>
        {openMenu && (
          <div
            style={{
              position: "absolute",
              top: "80px",
              right: "30px",
              width: "260px",
              background: !isDarkTheme ? "#fff" : "#181C27",
              borderRadius: "16px",
              boxShadow: "0 10px 25px rgba(0,0,0,0.15)",
              padding: "10px 0",
              zIndex: 999,
            }}
          >
            {menuItems.map((item, index) => (
              <div
                key={index}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "18px",
                  padding: "12px 18px",
                  cursor: "pointer",
                  transition: "background 0.2s",
                }}
                onClick={() => {
                  setOpenMenu((prev) => !prev);
                  if (item.label === "Switch Theme") {
                    setIsDarkTheme((prev) => !prev);
                  } else if (item.label === "Instructions") {
                    setShowInstructionsPopup(true);
                  } else if (item.label === "Assessment Details") {
                    setShowSubjectPopup(true);
                  }
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.background = isDarkTheme
                    ? "#1A2540"
                    : "#f5f7fb")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.background = "transparent")
                }
              >
                <img
                  src={item.icon}
                  alt=""
                  style={{ width: "25px", height: "15px" }}
                />

                <span
                  style={{
                    fontSize: "14px",
                    color: isDarkTheme ? "#ffff" : "#2c2c2c",
                    fontWeight: 500,
                  }}
                >
                  {item.label}
                </span>
              </div>
            ))}
          </div>
        )}
      </div>
      {/* Main Content Row - Fixed height to prevent overflow */}
      <Row
        className="question-with-options-container"
        style={{
          height: "calc(100vh - 180px)", // Fixed height instead of maxHeight
          marginBottom: "10px",
          overflow: "hidden", // Prevent double scrollbars
        }}
      >
        {/* Left Column - Questions */}
        <Col
          style={{ height: "100%", display: "flex", flexDirection: "column" }}
        >
          <div
            ref={questionContainerRef}
            className="question-box"
            style={{
              height: isProgramming ? "100%" : getContainerHeight(),
              minHeight: isProgramming ? "350px" : "auto",
              display: "flex",
              flexDirection: "column",
              overflow: isProgramming ? "hidden" : "auto", // Only scroll for non-programming
              backgroundColor: isDarkTheme ? "#0D0F14" : "",
            }}
          >
            {/* Programming Toolbar - Inside the white container */}
            {isProgramming && renderProgrammingToolbar()}

            <div
              className="question-content"
              style={{
                padding: "16px",
                overflow: isProgramming ? "auto" : "visible",
                flex: isProgramming ? 1 : "none",
              }}
            >
              <div
                className="question-text"
                style={{
                  fontSize: "15px",
                  marginBottom: "16px",
                  color: isDarkTheme ? "#FFFFFF" : "",
                }}
              >
                {currentQuestion?.question}
              </div>

              {currentQuestion.questionMediaUrls?.map((media, index) =>
                media.media_url ? (
                  <div
                    key={index}
                    style={{
                      display: "flex",
                      justifyContent:
                        currentQuestion.questionType === UserInput.imageType
                          ? "center"
                          : "flex-start",
                      width: "100%",
                      marginBottom: "16px",
                    }}
                  >
                    <ZoomableImage src={media.media_url} />
                  </div>
                ) : null,
              )}

              {/* Problem Statement and Instructions - Inside the white container */}
              {isProgramming && (
                <>
                  {currentQuestion.problem_statement && (
                    <div style={{ marginTop: "20px" }}>
                      <div
                        style={{
                          fontWeight: 600,
                          fontSize: "14px",
                          marginBottom: "8px",
                          color: "#1a1f24",
                        }}
                      >
                        Problem Statement
                      </div>
                      <div
                        style={{
                          fontSize: "13px",
                          lineHeight: 1.5,
                          color: "#333",
                          backgroundColor: "#f9f9f9",
                          padding: "12px",
                          borderRadius: "6px",
                          border: "1px solid #eee",
                        }}
                      >
                        {currentQuestion.problem_statement}
                      </div>
                    </div>
                  )}
                  {currentQuestion.instructions && (
                    <div style={{ marginTop: "16px" }}>
                      <div
                        style={{
                          fontWeight: 600,
                          fontSize: "14px",
                          marginBottom: "8px",
                          color: "#1a1f24",
                        }}
                      >
                        Instructions
                      </div>
                      <div
                        style={{
                          fontSize: "13px",
                          lineHeight: 1.5,
                          color: "#333",
                          backgroundColor: "#f9f9f9",
                          padding: "12px",
                          borderRadius: "6px",
                          border: "1px solid #eee",
                        }}
                      >
                        {currentQuestion.instructions}
                      </div>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </Col>

        {/* Vertical Divider */}
        {/* <div className="vertical-divider"></div> */}

        {/* Right Column - Options/Code Editor */}
        <Col
          style={{ height: "100%", display: "flex", flexDirection: "column" }}
        >
          <div
            className="options-container"
            style={{
              height: "100%",
              overflow: "auto", // Allow scrolling if content overflows
              justifyContent:
                currentQuestion.questionType === UserInput.imageType
                  ? "center"
                  : "",
            }}
          >
            {currentQuestion.questionType === UserInput.descriptive ? (
              <textarea
                value={descriptiveText!}
                onChange={(e) => onDescriptiveOptionChange(e.target.value)}
                placeholder="Type here..."
                rows={4}
                className="descriptive-assessment-question"
                style={{
                  minHeight: "200px",
                  height: "calc(100% - 40px)", // Take full height minus character counter
                  resize: "vertical",
                }}
              />
            ) : isProgramming ? (
              renderProgrammingEditor()
            ) : (
              <>
                {currentQuestion?.optionModelList.map((option, index) => (
                  <div
                    key={index}
                    ref={(ref) => (optionRefs.current[index] = ref!)}
                    className={
                      option.optionKey === selectedAnswerId
                        ? "option-selected"
                        : "option"
                    }
                    style={{
                      backgroundColor: isDarkTheme
                        ? option.optionKey === selectedAnswerId
                          ? "#825703"
                          : "#495672"
                        : "",
                      border: isDarkTheme
                        ? option.optionKey === selectedAnswerId
                          ? "#825703"
                          : "#495672"
                        : "",
                    }}
                    onClick={() => {
                      onOptionSelected(option);
                    }}
                  >
                    <div
                      className={
                        option.optionKey === selectedAnswerId
                          ? "option-label-selected"
                          : "option-label"
                      }
                      style={{
                        backgroundColor: isDarkTheme
                          ? option.optionKey === selectedAnswerId
                            ? "#A07726"
                            : "#8A95B4"
                          : "",
                      }}
                    >
                      {option.optionNumber}
                    </div>
                    <div
                      className="option-text"
                      style={{
                        color: isDarkTheme ? "#FFFFFF" : "",
                      }}
                    >
                      {option.optionText}
                    </div>{" "}
                  </div>
                ))}
              </>
            )}
            {currentQuestion.questionType === UserInput.descriptive && (
              <p
                className="descriptive-assessment-question-character"
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  fontSize: "12px",
                  marginTop: "8px",
                }}
              >
                {(descriptiveText ?? "").length}/{200} characters
              </p>
            )}
          </div>
        </Col>
      </Row>
      {isPopup && (
        <ErrorAlertPopup
          body={`Logging out will lead to your<br /> assessment being forfeited.`}
          subBody="Are you sure you still want to logout?"
          btn1Pressed={() => {
            assessmentLogout();
            setIsPopup(false);
          }}
          btn2Pressed={() => {
            setIsPopup(false);
          }}
        />
      )}
      {showNotification && (
        <SuccessSnackPopUp
          message={showNotification}
          onClose={handleCloseNotification}
        />
      )}
      {/* Bottom Navigation Bar - Fixed at bottom */}
      <Row
        className="assessment-bottom-container"
        style={{
          marginTop: "0",
          // padding: "0 20px",
          paddingTop: "10px",
          paddingBottom: "10px",
          paddingLeft: "10px",
          paddingRight: "10px",
          position: "relative",
          zIndex: 10,
          backgroundColor: isDarkTheme ? "#0D0F14" : "",
        }}
      >
        <Col className="audio-element">
          {currentQuestion.questionAudio && (
            <AudioPlayer
              key={currentIndex}
              src={currentQuestion.questionAudio}
            />
          )}
        </Col>
        <Col>
          <div className="bottom-button-container">
            <img
              src={
                currentIndex == 0 ? BackwardImgDisabled : BackwardImgDisabled
              }
              onClick={() => {
                handlePrevious();
                clearEnableSaveStateButton();
              }}
              alt="previous icon"
              className="previous-icon"
            />

            <div
              className="review-later-button"
              onClick={handleReviewFlag}
              style={{
                backgroundColor: isDarkTheme ? "#3E4A65" : "",
              }}
            >
              <img src={ReviewFlag} className="review-flag" alt="review-flag" />
              <div
                className="review-later-text"
                style={{
                  color: isDarkTheme ? "#FFFFFF" : "",
                }}
              >
                Review Later
              </div>
            </div>

            <button
              className={
                (currentQuestion?.optionModelList &&
                  currentQuestion?.optionModelList.some(
                    (option) => option.selected === true,
                  ) &&
                  currentIndex === questionModelList.length - 1 &&
                  isLoading === false) ||
                (currentIndex !== questionModelList.length - 1 &&
                  currentQuestion.saved === false &&
                  selectedAnswerId != null &&
                  isLoading === false) ||
                (currentIndex === questionModelList.length - 1 &&
                  currentQuestion?.questionType === UserInput.descriptive &&
                  descriptiveText !== "" &&
                  isLoading === false) ||
                (currentIndex !== questionModelList.length - 1 &&
                  currentQuestion?.questionType === UserInput.descriptive &&
                  currentQuestion.saved === false &&
                  descriptiveText !== "" &&
                  isLoading === false) ||
                (currentIndex === questionModelList.length - 1 &&
                  isProgramming &&
                  codeContent.trim() !== "" &&
                  isLoading === false) ||
                (currentIndex !== questionModelList.length - 1 &&
                  isProgramming &&
                  currentQuestion.saved === false &&
                  codeContent.trim() !== "" &&
                  isLoading === false)
                  ? "assessment-next-button"
                  : "assessment-next-button-unselected"
              }
              style={{
                color: isDarkTheme
                  ? (currentQuestion?.optionModelList &&
                      currentQuestion?.optionModelList.some(
                        (option) => option.selected === true,
                      ) &&
                      currentIndex === questionModelList.length - 1 &&
                      isLoading === false) ||
                    (currentIndex !== questionModelList.length - 1 &&
                      currentQuestion.saved === false &&
                      selectedAnswerId != null &&
                      isLoading === false) ||
                    (currentIndex === questionModelList.length - 1 &&
                      currentQuestion?.questionType === UserInput.descriptive &&
                      descriptiveText !== "" &&
                      isLoading === false) ||
                    (currentIndex !== questionModelList.length - 1 &&
                      currentQuestion?.questionType === UserInput.descriptive &&
                      currentQuestion.saved === false &&
                      descriptiveText !== "" &&
                      isLoading === false) ||
                    (currentIndex === questionModelList.length - 1 &&
                      isProgramming &&
                      codeContent.trim() !== "" &&
                      isLoading === false) ||
                    (currentIndex !== questionModelList.length - 1 &&
                      isProgramming &&
                      currentQuestion.saved === false &&
                      codeContent.trim() !== "" &&
                      isLoading === false)
                    ? "#000000"
                    : "#FFFFFF"
                  : "",
              }}
              onClick={() => {
                if (
                  ((currentQuestion?.optionModelList &&
                    currentQuestion?.optionModelList.some(
                      (option) => option.selected === true,
                    ) &&
                    currentIndex === questionModelList.length - 1) ||
                    (currentIndex !== questionModelList.length - 1 &&
                      currentQuestion.saved === false &&
                      selectedAnswerId != null) ||
                    (currentIndex === questionModelList.length - 1 &&
                      currentQuestion?.questionType === UserInput.descriptive &&
                      descriptiveText !== "") ||
                    (currentIndex !== questionModelList.length - 1 &&
                      currentQuestion?.questionType === UserInput.descriptive &&
                      currentQuestion.saved === false &&
                      descriptiveText !== "") ||
                    (currentIndex === questionModelList.length - 1 &&
                      isProgramming &&
                      codeContent.trim() !== "" &&
                      isLoading === false) ||
                    (currentIndex !== questionModelList.length - 1 &&
                      isProgramming &&
                      currentQuestion.saved === false &&
                      codeContent.trim() !== "" &&
                      isLoading === false)) &&
                  isLoading === false
                ) {
                  handleSaveNextSubmit();
                }
              }}
            >
              {currentIndex === totalQuestions - 1 ? "Submit" : "Save & Next"}
            </button>

            <img
              src={
                currentIndex >= questionModelList.length - 1
                  ? ForwardImgDisabled
                  : ForwardImgDisabled
              }
              onClick={() => {
                handleForward();
                clearEnableSaveStateButton();
              }}
              alt="previous icon"
              className="previous-icon"
            />
          </div>
        </Col>
      </Row>
      {/*Overlay Popups */}
      {isReviewErrorPopup && (
        <OverlayErrorPoppup
          title="Info"
          body="You have questions marked for review. Do you wish to submit?"
          button1Text="Review"
          button2Text="Submit"
          button1CallBack={() => {
            setIsReviewErrorPopup(false);
          }}
          button2CallBack={() => {
            handleSaveNextSubmit();
          }}
        />
      )}
      {isSetErrorMsg !== null && (
        <OverlaySingleErrorPoppup
          title="Error"
          body={isSetErrorMsg}
          button1Text="Ok"
          button1CallBack={() => {
            setIsErrorMsgPopup(null);
          }}
        />
      )}
      {showInstructionsPopup && (
        <div
          className={`assessmentInstructionOverlay ${
            isDarkTheme ? "darkThemePopup" : "lightThemePopup"
          }`}
        >
          <div className="assessmentInstructionPopup">
            <div className="assessmentInstructionHeader">
              <div>Assessment Instructions</div>

              <button
                className="assessmentCloseBtn"
                onClick={() => setShowInstructionsPopup(false)}
              >
                ✕
              </button>
            </div>

            <div className="assessmentInstructionGrid">
              {instructionList.map((item, index) => (
                <div className="instructionCard" key={index}>
                  <img src={item.image} alt="" />
                  <p>{item.text}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
      {showSubjectPopup && (
        <div className="dashboarCardoverlay">
          {selectedAssessment && (
            <div
              className={`assessmentInfoContainer ${
                isDarkTheme ? "darkAssessmentTheme" : "lightAssessmentTheme"
              }`}
            >
              {/* HEADER */}
              <div className="assessmentInfoHeader">
                <h2>Assessment Information</h2>

                <button
                  className="assessmentCloseBtn"
                  onClick={() => setShowSubjectPopup(false)}
                >
                  ✕
                </button>
              </div>

              {(() => {
                const total =
                  (selectedAssessment.dimension_questions ? 1 : 0) +
                  (selectedAssessment.category_list?.length || 0) +
                  (selectedAssessment.curriculum_list?.length || 0);

                const jozuna = selectedAssessment.dimension_questions
                  ? ["JOZUNA Skills"]
                  : [];

                const curriculum = (selectedAssessment.category_list || []).map(
                  (c: any) => c.category_name,
                );

                const industry = (selectedAssessment.curriculum_list || []).map(
                  (c: any) => c.curriculum_name,
                );

                return (
                  <>
                    {/* TOP INFO */}
                    <div className="assessmentInfoTop">
                      <div>
                        <div className="assessmentBadge">Industry</div>

                        <div className="assessmentTitle">
                          {selectedAssessment.assessment_entity_name}
                        </div>
                      </div>

                      <div className="assessmentRemainingTime">
                        ⏰ 3 Hours Remaining
                      </div>
                    </div>

                    {/* DETAILS */}
                    <div
                      className={`assessmentDetailsRow${
                        isDarkTheme
                          ? "darkAssessmentTheme"
                          : "lightAssessmentTheme"
                      }`}
                    >
                      <div>
                        <div>❓ 24 Questions</div>

                        <div>
                          📚 {total}{" "}
                          {total > 1
                            ? "Subject Distribution"
                            : "Subjects Distribution"}
                        </div>
                      </div>
                      <div>🕒 60 Minutes Duration</div>
                    </div>

                    {/* SUBJECT CARDS */}
                    <div className="assessmentSubjectGrid">
                      {/* JOZUNA */}
                      {jozuna.length > 0 && (
                        <div className="assessmentSubjectCard">
                          <div className="assessmentSubjectHeader">Jozuna:</div>

                          <div className="assessmentSubjectBody">
                            {jozuna.map((item: string, i: number) => (
                              <div key={i}>• {item}</div>
                            ))}
                          </div>
                        </div>
                      )}

                      {/* CURRICULUM */}
                      {curriculum.length > 0 && (
                        <div className="assessmentSubjectCard">
                          <div className="assessmentSubjectHeader">
                            Curriculum:
                          </div>

                          <div className="assessmentSubjectBody">
                            {curriculum.map((item: string, i: number) => (
                              <div key={i}>• {item}</div>
                            ))}
                          </div>
                        </div>
                      )}

                      {/* INDUSTRY */}
                      {industry.length > 0 && (
                        <div className="assessmentSubjectCard">
                          <div className="assessmentSubjectHeader">
                            Industry:
                          </div>

                          <div className="assessmentSubjectBody">
                            {industry.map((item: string, i: number) => (
                              <div key={i}>• {item}</div>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>
                  </>
                );
              })()}
            </div>
          )}
        </div>
      )}{" "}
    </div>
  );
};

export default AssessmentQuestionPage;
